import { isSystem } from '@umu/umu-util';

import * as imageUtil from '@umu/umu-image-handle';
import { CERTIFICATE_FORMAT } from '../interface';
export { getElementExhibitConf, QR_CODE_WIDTH } from './enterprise';
import {
    defaultThemeInfo,
    HorizontalWidth,
    VerticalWidth,
    getTranslateThemeInfo,
    getThemeIndex,
    getDefaultThemeId,
    getPlatform,
} from './common';

const convertImage2PngFormat = (imgUrl: string) => {
    // @ts-ignore
    return isSystem('CN') ? imageUtil.convertFormat(imgUrl, 'png') : imgUrl;
};

const getDefaultScaleInfo = (displayStyle = CERTIFICATE_FORMAT.VERTICAL): [number, number, boolean, boolean] => {
    const isHorizontal = Number(displayStyle) === CERTIFICATE_FORMAT.HORIZONTAL;
    const isVertical = Number(displayStyle) === CERTIFICATE_FORMAT.VERTICAL;
    return isHorizontal
        ? [HorizontalWidth, VerticalWidth, isHorizontal, isVertical]
        : [VerticalWidth, HorizontalWidth, isHorizontal, isVertical];
};
// 实现一个函数 转化px为rem， 参数可能为数字或者字符串 数字直接转化，字符串需要判断是否带px单位，如果带则去掉px再转化，否则直接返回
const transformPx2Rem = (value: number | string): string => {
    let pxValue: number;

    if (typeof value === 'number') {
        pxValue = value;
    } else if (typeof value === 'string') {
        if (value.endsWith('px')) {
            pxValue = Number(value.slice(0, -2));
        } else {
            return value;
        }
    } else {
        throw new Error('Invalid type for value. Expected number or string.');
    }

    const remValue = pxValue / 100;
    return `${remValue}rem`;
}

export {
    transformPx2Rem,
    HorizontalWidth,
    VerticalWidth,
    defaultThemeInfo,
    getDefaultThemeId,
    getThemeIndex,
    getPlatform,
    getTranslateThemeInfo,
    getDefaultScaleInfo,
    convertImage2PngFormat,
};
